module.exports = __webpack_public_path__ + "img/CapCompras.be564584.png";